/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef, useState, useEffect } from 'react';
import { NavLink as RouterLink, withRouter } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, Button, Collapse, colors } from '@material-ui/core';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%'
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  nestedButton: {
    color: colors.blueGrey[800],
    padding: '10px 8px 10px 24px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
    }
  },
  expandIcon: {
    marginLeft: 'auto',
    color: colors.blueGrey[400]
  },
  nestedList: {
    width: '100%'
  }
}));

const CustomRouterLink = forwardRef((props, ref) => (
  <div
    ref={ref}
    style={{ width: '100%' }}
  >
    <RouterLink {...props} />
  </div>
));

const SidebarNav = props => {
  const { pages, className, location, ...rest } = props;

  const classes = useStyles();
  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    const currentPath = location && location.pathname ? location.pathname : '';
    setOpenGroups(prev => {
      const nextState = { ...prev };
      pages.forEach(page => {
        if (page.children) {
          const isChildActive = page.children.some(child =>
            currentPath === child.href || (child.href !== '/' && currentPath.startsWith(child.href))
          );
          if (isChildActive) {
            nextState[page.title] = true;
          }
        }
      });
      return nextState;
    });
  }, [location, pages]);

  const handleToggle = (title) => {
    setOpenGroups(prev => ({
      ...prev,
      [title]: !prev[title]
    }));
  };

  return (
    <List
      {...rest}
      className={clsx(classes.root, className)}
    >
      {pages.map(page => {
        if (page.children) {
          const isOpen = Boolean(openGroups[page.title]);
          return (
            <React.Fragment key={page.title}>
              <ListItem
                className={classes.item}
                disableGutters
              >
                <Button
                  className={classes.button}
                  onClick={() => handleToggle(page.title)}
                >
                  <div className={classes.icon}>{page.icon}</div>
                  {page.title}
                  {isOpen ? (
                    <ExpandLess className={classes.expandIcon} />
                  ) : (
                    <ExpandMore className={classes.expandIcon} />
                  )}
                </Button>
              </ListItem>
              <Collapse
                in={isOpen}
                timeout="auto"
                unmountOnExit={false}
              >
                <List className={classes.nestedList} disablePadding>
                  {page.children.map(child => (
                    <ListItem
                      className={classes.item}
                      disableGutters
                      key={child.title}
                    >
                      <Button
                        activeClassName={classes.active}
                        className={classes.nestedButton}
                        component={CustomRouterLink}
                        to={child.href}
                      >
                        <div className={classes.icon}>{child.icon}</div>
                        {child.title}
                      </Button>
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          );
        }

        return (
          <ListItem
            className={classes.item}
            disableGutters
            key={page.title}
          >
            <Button
              activeClassName={classes.active}
              className={classes.button}
              component={CustomRouterLink}
              to={page.href}
            >
              <div className={classes.icon}>{page.icon}</div>
              {page.title}
            </Button>
          </ListItem>
        );
      })}
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired,
  location: PropTypes.object
};

export default withRouter(SidebarNav);

